import React from "react";
import {Box, Link} from "@mui/material";
import {useTranslation} from "react-i18next";
import MermaidGraphViewer from "../mermaid-chart";
import {getOdataDataQueryUrl} from "../../utils/odata";
import {getMermaidGraphFromODataQuery} from "./utils";

const OdataGraphViewer = ({baseurl, datasource, mainentityset, query}) => {
  const {t} = useTranslation();
  return (
    baseurl &&
    datasource &&
    mainentityset &&
    query && (
      <>
        <Box>
          <span>{t("components.odataGraphViewer.query.label") + ": "}</span>
          <Link
            href={getOdataDataQueryUrl(baseurl, datasource, mainentityset, query)}
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
          >
            {decodeURIComponent(getOdataDataQueryUrl(baseurl, datasource, mainentityset, query))}
          </Link>
        </Box>
        <Box
          sx={{
            marginTop: "16px",
            display: "flex",
            justifyContent: "center",
            "& > *": {
              width: "75% !important"
            }
          }}
        >
          <MermaidGraphViewer graphDefinition={getMermaidGraphFromODataQuery(mainentityset, query)} />
        </Box>
      </>
    )
  );
};

export default OdataGraphViewer;
